import styled from "@emotion/styled";

import { ContentItemPlusSecondary } from "scmp-app/components/content/content-item-render/variants/plus-secondary";

export const StyledContentItemPlusSecondary = styled(ContentItemPlusSecondary)``;

export const ContentItemContainer = styled.div`
  ${StyledContentItemPlusSecondary}:nth-child(n+2) {
    margin-block-start: 16px;
    border-block-start: 1px solid rgba(0, 0, 0, 0.2);

    padding-block-start: 16px;
  }
`;

export const Container = styled.div``;
